import { em } from 'polished'
import styled from 'styled-components'

import { TextCartDescr } from 'styles/components/typography'

export const CrossedCostBlock = styled.div`
  line-height: 0;
  white-space: nowrap;
`

export const MutedCostBox = styled.span`
  opacity: ${p => p.theme.blocks.blockMutedOpacity};
`

export const SubscriptionTextWrapper = styled.div`
  display: inline-block;
  line-height: 0;
  position: relative;
`

export const SubscriptionText = styled(TextCartDescr)`
  display: block;
  position: absolute;
  top: 100%;
  left: 0;
  width: ${em(150)};
  /*Fix for safari: Remove block from viewport when it programmatically hide*/
  transform: translate3d(0, 0, 0);

  ${p => p.theme.mq.upLg} {
    top: 0;
    left: calc(100% + ${em(10)});
  }
`
